<template>
	<div class="laptop-overflow">
		<article class="tran-blue-tags">
			<span class="text-blue mr-2">ID:</span>{{ interview.interviewRequestID }}
		</article>
		<section
			v-if="interview.panelMeetingStatus == 0"
			class="id-tag add-gap d-flex mt-3"
		>
			<span class="blue-card-red-text fw-400">Cancelled By:</span>
			<span class="blue-card-red-text fw-600">{{
				interview.cancelledBy == "Panel" ? "You" : "Others"
			}}</span>
		</section>

		<section
			class="mt-3"
			v-if="interview.cancelledBy == 'Panel' && interview.remarks"
		>
			<span class="fam-mont fw-LM fs-12 text-3A3C40 w12">Remarks: </span>
			<div class="fam-mont fw-M fs-13 text-3A3C40 word-break mt-1">
				{{ interview.remarks }}
			</div>
		</section>

		<hr v-if="interview.panelMeetingStatus == 0" class="hr-back" />

		<h5 class="fam-lato fw-LM fs-14 text-3A3C40 mt-2">
			{{ formattedData(interview.name) }}
		</h5>

		<div class="d-flex justify-content-between">
			<h5
				v-if="$route.name != 'JobDetails'"
				class="d-flex align-items-start fam-lato fw-LM fs-13 text-3A3C40 gap-2 w-75 text-break"
			>
				<img src="../assets/newdesign/dashboard/blueMail.svg" alt="" />{{
					interview.emailID
				}}
			</h5>
			<div class="tran-row-tag">
				<img :src="getRupeeImage(interviewData.level, interview)" alt="" />
				{{ interview.amount }}
			</div>
		</div>
		<h5
			:class="$route.name == 'JobDetails' && 'mt-2'"
			class="d-flex align-items-center fam-lato fw-M fs-13 text-darkgrey gap-2 tran-blue-tags-2"
		>
			<img src="../assets/newdesign/jobsearch/blueClock.svg" alt="" />{{
				getFormattedTime(interview)
			}}
		</h5>
		<div class="d-flex mt-1">
			<span class="fam-mont fw-LM fs-12 text-3A3C40 w12">Skills :</span>
			<div class="fam-mont fw-M fs-13 text-3A3C40 ml-2 w83">
				{{
					interview.candidateSkills && interview.candidateSkills.length != 0
						? formattedArray(interview.candidateSkills).join(", ")
						: "-"
				}}
			</div>
		</div>
		<hr id="hideinmobile" class="hr-back" />
		<div
			@click="goToProfile()"
			class="tran-cand-prof d-flex align-items-center fam-mont fs-16 fw-M text-blue mt-3"
		>
			Candidate Profile
			<img :class="!interview.link && 'not-allowed opac-5'" src="../assets/newdesign/home/roundRightArrow.svg" alt="" />
		</div>
		<div>
			<h5 class="fam-mont fw-LM fs-12 text-3A3C40 mt-3">Job Name</h5>
			<h5 class="fam-mont fw-M fs-13 text-3A3C40">
				{{ formattedData(interview.jobName) }}
			</h5>
			<h5 class="fam-mont fw-LM fs-12 text-3A3C40 mt-3">Job Type</h5>
			<h5 class="fam-mont fw-M fs-13 text-3A3C40">
				{{ formattedData(interview.jobType) }}
			</h5>
			<h5 class="fam-mont fw-LM fs-12 text-3A3C40 mt-3">Job Role</h5>
			<h5 class="fam-mont fw-M fs-13 text-3A3C40">
				{{ formattedData(interview.role) }}
			</h5>
			<h5 class="fam-mont fw-LM fs-12 text-3A3C40 mt-3">Job Description</h5>
			<div v-html="interview.description"></div>
			<h5 class="fam-mont fw-LM fs-12 text-3A3C40 mt-3">Skills</h5>
			<h5 class="fam-mont fw-M fs-13 text-3A3C40">
				{{ formattedArray(interview.skills).join(", ") }}
			</h5>
		</div>
	</div>
</template>

<script>
import { mapGetters } from "vuex";
import {
	formattedData,
	getRupeeImage,
	getFormattedTime,
	formattedArray,
} from "@/components/PanelDasboard/panelHelpers";

export default {
	data() {
		return {
			interview: null,
		};
	},
	computed: {
		...mapGetters("candidateVUEX", {
			interviewData: "getInterview",
		}),
		...mapGetters("candidateVUEX", {
			candidateInfo: "getcandidateInfo",
		}),
	},
	created() {
		if (this.$route.name == "JobDetails") {
			this.interview = this.interviewData.interview;
		}
	},
	methods: {
		formattedArray(skills) {
			return formattedArray(skills);
		},
		getFormattedTime(interview) {
			return getFormattedTime(interview);
		},
		formattedData(data) {
			return formattedData(data);
		},
		goToProfile() {
			window.open(this.interview.link);
		},
		getRupeeImage(level, interview) {
			return getRupeeImage(level, interview);
		},
	},
};
</script>

<style>
.tran-blue-tags {
	background: #f6f9fb;
	border-radius: 20px;
	padding: 2px 10px;
	width: fit-content;
	font-size: 11px;
	font-weight: 500;
	font-family: "Lato", sans-serif;
	color: #3a3c40;
}
.tran-blue-tags-2 {
	background: #f6f9fb;
	border-radius: 4px;
	padding: 4px 6px;
	width: fit-content;
}

.tran-row-tag {
	font-family: "Montserrat", sans-serif;
	font-weight: 600;
	font-size: 12px;
	color: #3a3c40;
	background: #20639b1a;
	border-radius: 20px;
	display: flex;
	align-items: center;
	gap: 5px;
	padding: 2px 8px;
	height: fit-content;
}
@media (max-width: 1028px) {
	.tran-cand-prof {
		position: unset !important;
		border-top: 1px solid #e2e2e2 !important;
		border-bottom: 1px solid #e2e2e2 !important;
		padding-block: 10px !important;
		justify-content: space-between;
	}
}
.tran-cand-prof {
	position: absolute;
	top: 0px;
	right: 63px;
	padding: 0;
	border-color: #fff;
	gap: 5px;
}
</style>
